/* STOICINDEX · motion v2 — reveals + manifiesto iluminado por scroll */
(function () {
  'use strict';
  if (window.__stoicMotion) return;
  window.__stoicMotion = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Los estados ocultos de CSS solo se aplican bajo html.stoic-js:
     si este script no llega a ejecutarse, todo el contenido es visible. */
  if (!reduced && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('stoic-js');
  }

  /* Reveal genérico */
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-inview');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
    );
    document.querySelectorAll('[data-stoic-reveal]').forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll('[data-stoic-reveal]').forEach(function (el) {
      el.classList.add('is-inview');
    });
  }

  /* Manifiesto: envolver palabras y encenderlas según el progreso de scroll */
  document.querySelectorAll('.stoic-manifesto__text').forEach(function (container) {
    var words = [];
    function wrapWords(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        var frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(function (part) {
          if (/^\s+$/.test(part) || part === '') {
            frag.appendChild(document.createTextNode(part));
          } else {
            var span = document.createElement('span');
            span.className = 'stoic-word';
            span.textContent = part;
            frag.appendChild(span);
            words.push(span);
          }
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        Array.prototype.slice.call(node.childNodes).forEach(wrapWords);
      }
    }
    wrapWords(container);
    if (reduced || words.length === 0) {
      words.forEach(function (w) { w.classList.add('is-lit'); });
      return;
    }

    var lit = -1;
    var ticking = false;
    function update() {
      ticking = false;
      var rect = container.getBoundingClientRect();
      var vh = window.innerHeight;
      /* progreso: 0 cuando el bloque entra, 1 cuando su base llega al 40% del viewport */
      var total = rect.height + vh * 0.35;
      var progress = (vh * 0.75 - rect.top) / total;
      progress = Math.max(0, Math.min(1, progress));
      var target = Math.floor(progress * words.length);
      if (target === lit) return;
      if (target > lit) {
        for (var i = lit + 1; i <= target && i < words.length; i++) words[i].classList.add('is-lit');
      } else {
        for (var j = lit; j > target && j >= 0; j--) words[j].classList.remove('is-lit');
      }
      lit = target;
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  });

  /* Producto: isla de compra flotante al pasar el hero */
  var buybar = document.querySelector('[data-stoic-buybar]');
  var phero = document.querySelector('.stoic-phero');
  if (buybar && phero) {
    var buybarTick = false;
    var updateBuybar = function () {
      buybarTick = false;
      var rect = phero.getBoundingClientRect();
      buybar.classList.toggle('is-visible', rect.bottom < 80);
    };
    window.addEventListener('scroll', function () {
      if (!buybarTick) {
        buybarTick = true;
        requestAnimationFrame(updateBuybar);
      }
    }, { passive: true });
    updateBuybar();
  }

  /* Producto: carrusel de fotos (scroll-snap + flechas + puntos) */
  document.querySelectorAll('[data-stoic-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-stoic-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.stoic-phero__slide');
    var dotsWrap = carousel.querySelector('[data-stoic-dots]');
    var dots = [];
    if (dotsWrap && slides.length > 1) {
      slides.forEach(function (_, i) {
        var d = document.createElement('span');
        d.className = 'stoic-phero__dot' + (i === 0 ? ' is-active' : '');
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }
    function currentIndex() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function goTo(i) {
      var max = slides.length - 1;
      if (i < 0) i = max;
      if (i > max) i = 0;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    }
    var prev = carousel.querySelector('[data-stoic-prev]');
    var next = carousel.querySelector('[data-stoic-next]');
    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
    var scrollTick = false;
    track.addEventListener('scroll', function () {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(function () {
        scrollTick = false;
        var idx = currentIndex();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      });
    }, { passive: true });
  });

  /* Lightbox para imágenes ampliables ([data-stoic-zoom]) */
  (function () {
    if (!document.querySelector('[data-stoic-zoom]')) return;
    var box = document.createElement('div');
    box.className = 'stoic-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Imagen ampliada');
    box.innerHTML =
      '<img class="stoic-lightbox__img" alt="">' +
      '<button type="button" class="stoic-lightbox__close" aria-label="Cerrar">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m3 3 10 10M13 3 3 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      '</button>';
    document.body.appendChild(box);
    var img = box.querySelector('.stoic-lightbox__img');
    var closeBtn = box.querySelector('.stoic-lightbox__close');
    var lastTrigger = null;

    function open(url, alt) {
      img.src = url;
      img.alt = alt || '';
      box.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      closeBtn.focus();
    }
    function close() {
      box.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-stoic-zoom]');
      if (trigger) {
        lastTrigger = trigger;
        var inner = trigger.querySelector('img');
        open(trigger.getAttribute('data-stoic-zoom'), inner ? inner.alt : '');
      }
    });
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('.stoic-lightbox__close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) close();
    });
  })();

  /* Hero: palabra rotatoria */
  document.querySelectorAll('[data-stoic-cycle]').forEach(function (cycle) {
    var words = cycle.querySelectorAll('.stoic-hero__cycle-word');
    if (words.length < 2 || reduced) return;
    var current = 0;
    setInterval(function () {
      var prev = words[current];
      current = (current + 1) % words.length;
      var next = words[current];
      prev.classList.remove('is-current');
      prev.classList.add('is-leaving');
      prev.setAttribute('aria-hidden', 'true');
      next.classList.remove('is-leaving');
      next.classList.add('is-current');
      next.removeAttribute('aria-hidden');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 600);
    }, 2600);
  });

  /* Hero: peso tipográfico magnético alrededor del cursor (solo puntero fino) */
  if (!reduced && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('[data-stoic-magnet]').forEach(function (heading) {
      var chars = [];
      heading.querySelectorAll('.stoic-hero__line > span').forEach(function (lineEl) {
        Array.prototype.slice.call(lineEl.childNodes).forEach(function (node) {
          if (node.nodeType !== Node.TEXT_NODE) return; /* no tocar la palabra serif */
          var frag = document.createDocumentFragment();
          node.textContent.split('').forEach(function (ch) {
            if (ch.trim() === '') {
              frag.appendChild(document.createTextNode(ch));
            } else {
              var s = document.createElement('span');
              s.className = 'stoic-char';
              s.textContent = ch;
              frag.appendChild(s);
              chars.push(s);
            }
          });
          node.parentNode.replaceChild(frag, node);
        });
      });
      if (chars.length === 0) return;

      var mx = -9999, my = -9999, raf = null;
      var RADIUS = 180, BASE = 640, PEAK = 700;
      function paint() {
        raf = null;
        for (var i = 0; i < chars.length; i++) {
          var r = chars[i].getBoundingClientRect();
          var dx = r.left + r.width / 2 - mx;
          var dy = r.top + r.height / 2 - my;
          var d = Math.sqrt(dx * dx + dy * dy);
          var t = Math.max(0, 1 - d / RADIUS);
          var w = BASE + (PEAK - BASE) * t * t;
          chars[i].style.fontVariationSettings = "'wght' " + w.toFixed(0);
        }
      }
      heading.addEventListener('pointermove', function (e) {
        mx = e.clientX;
        my = e.clientY;
        if (!raf) raf = requestAnimationFrame(paint);
      });
      heading.addEventListener('pointerleave', function () {
        mx = -9999;
        my = -9999;
        if (!raf) raf = requestAnimationFrame(paint);
      });
    });
  }
})();
